import ApiService, { HTTPMethod } from './api.core'
import { buildQueryParamsUrl } from '../services/utils'

class ClaimsApi {
  async submitClaim(
    insuranceId,
    incidentTime,
    incidentLocation,
    incidentDetails,
    reason,
    claimType,
    phoneNumber,
    witnessesDetails,
    damageAndFootageImages,
    flightLogs,
    damagedDrones,
    damagedEquipment,
    pilotCertificate,
    aircraftRegistrationCertificates
  ) {
    var data = new FormData()
    data.append('InsuranceId', insuranceId)
    data.append('IncidentTime', new Date(incidentTime).toUTCString())
    data.append('IncidentDetails', incidentDetails)
    data.append('Reason', reason)
    data.append('ClaimType', claimType)
    data.append('PhoneNumber', encodeURIComponent(phoneNumber))
    data.append('WitnessesDetails', encodeURIComponent(witnessesDetails))
    data.append('IncidentLocation', incidentLocation)

    for (let i = 0; i < damagedDrones.length; i++) {
      data.append(`DamagedDrones[${i}]`, JSON.stringify(damagedDrones[i]))
    }
    for (let i = 0; i < damagedEquipment.length; i++) {
      data.append(`DamagedEquipment[${i}]`, JSON.stringify(damagedEquipment[i]))
    }

    for (let i = 0; i < damageAndFootageImages.length; i++) {
      data.append('DamageAndFootageImages', damageAndFootageImages[i])
    }

    for (let i = 0; i < flightLogs.length; i++) {
      data.append('FlightLogs', flightLogs[i])
    }

    for (let i = 0; i < pilotCertificate.length; i++) {
      data.append('PilotCertificate', pilotCertificate[i])
    }

    for (let i = 0; i < aircraftRegistrationCertificates.length; i++) {
      data.append(
        'AircraftRegistrationCertificates',
        aircraftRegistrationCertificates[i]
      )
    }

    return ApiService.fetch('claims/me', HTTPMethod.POST, data, false)
  }
}

export default new ClaimsApi()
